module.exports = __webpack_public_path__ + "img/loons_02.6b6739b6.png";